import {h, Fragment} from "preact"
import { SerpElement, useCurrencyFormatting } from '@nosto/preact'
import { useEffect, useState, useRef, useMemo, useCallback } from 'preact/hooks';
// import OoSModal from './OoSModal'

export const convertToImgixImage = (imageUrl, width = 500, height = 800, productTags = '') => {
    if (!imageUrl) return '';
    let trim = '&trim=color&trimtol=18&trimcolor=fff';
    if (productTags.includes('SKIP_CROP')) {
        trim = '';
    }
    return (
        imageUrl.replace('https://cdn.shopify.com', 'https://villoid-shop.imgix.net') +
        `${trim}&auto=compress&jpeg-progressive=true&width=${width}&height=${height}`
    )
}

export const customOrderSizes = [
    'XXS',
    'XXS/XS',
    'XXS/S',
    'XS',
    'XS/S',
    'XS/32',
    'S',
    'S/30',
    'S/32',
    'S/M',
    'M',
    'M/32',
    'M/L',
    'L',
    'L/32',
    'L/XL',
    'XL',
    'XL/XXL',
    'XXL',
    '0',
    '1',
    '2',
    '4',
    '5',
    '6',
    '7',
    '7,5',
    '8',
    '9',
    '10',
    '12',
    '31',
    '32',
    '32/34',
    '34',
    '34L',
    '34/L32',
    '35',
    '35.5',
    '35/36',
    '35/38',
    '36',
    '36 ⅓',
    '36,5',
    '36.5',
    '36/37',
    '36 ⅔',
    '36L',
    '36/38',
    '36/L32',
    '37',
    '37 ⅓',
    '37,5',
    '37.5',
    '37 ⅔',
    '37/38',
    '37/39',
    '38',
    '38 ⅓',
    '38,5',
    '38.5',
    '38 ⅔',
    '38L',
    '38/L32',
    '39',
    '39 ⅓',
    '39,5',
    '39.5',
    '39 ⅔',
    '39/40',
    '39/41',
    '39-41',
    '39/42',
    '40',
    '40,5',
    '40.5',
    '40/41',
    '40 ⅔',
    '40L',
    '40/L32',
    '41',
    '41 ⅓',
    '41,5',
    '41.5',
    '41/42',
    '41/43',
    '41/44',
    '42',
    '42,5',
    '42.5',
    '42 ⅓',
    '42/43',
    '42/44',
    '42/45',
    '42L',
    '42/L32',
    '43',
    '43 ⅓',
    '43,5',
    '43.5',
    '43/44',
    '43/45',
    '43/46',
    '44',
    '44.5',
    '44 ⅔',
    '44L',
    '44/L32',
    '44/W32',
    '44/45',
    '44/46',
    '44/47',
    '45',
    '45.5',
    '45/46',
    '45/47',
    '45/48',
    '46',
    '46,5',
    '46/47',
    '46/48',
    '47',
    '47,5',
    '47/48',
    '48',
    '49',
    '50',
    '51',
    '52',
    '53',
    '54',
    '55',
    '56',
    '57',
    '58',
    '59',
    '60',
    '61',
    '62',
    '70',
    '75',
    '80',
    '85',
    '90',
    '95',
    '105',
    'Høyre',
    'One Size',
    'One size',
    'Venstre',
    'W24',
    'W24/L30',
    'W24/L32',
    'W24/L34',
    'W24/L36',
    'W25',
    'W25/L30',
    'W25/L32',
    'W25/L34',
    'W25/L36',
    'W26',
    'W26/L30',
    'W26/L32',
    'W26/L34',
    'W26/L36',
    'W27',
    'W27/L30',
    'W27/L32',
    'W27/L34',
    'W27/L36',
    'W28',
    'W28/L30',
    'W28/L32',
    'W28/L34',
    'W28/L36',
    'W29',
    'W29/L30',
    'W29/L32',
    'W29/L34',
    'W29/L36',
    'W30',
    'W30/L30',
    'W30/L32',
    'W30/L34',
    'W30/L36',
    'W31',
    'W31/L30',
    'W31/L32',
    'W31/L34',
    'W31/L36',
    'W32',
    'W32/L30',
    'W32/L32',
    'W32/L34',
    'W32/L36',
    'W33',
    'W33/L30',
    'W33/L32',
    'W33/L34',
    'W33/L36',
    'W34',
    'W34/L30',
    'W34/L32',
    'W34/L34',
]

export const customSortSizes = (a, b) => {
    const indexA = customOrderSizes.indexOf(a)
    const indexB = customOrderSizes.indexOf(b)

    if (indexA === -1 && indexB === -1) {
        // Case-insensitive comparison if both values are not in customOrderSizes
        return (a + "").toLowerCase().localeCompare((b + "").toLowerCase())
    }
    if (indexA === -1) return 1
    if (indexB === -1) return -1
    return indexA - indexB
}

const handleBackInStock = (e, sku, selectedSwatch) => {
    e.preventDefault()
    e.stopPropagation()

    const size = sku.attributes.find(a => a.key === 'SIZE')?.value;

    const backInStockModal = new BackInStockModal({
        variantId: sku.id,
        productId: selectedSwatch.productId,
        productTitle: selectedSwatch.name.split('/')[0].replace('-', '') + (size ? ` - ${size}` : ''),
        variantTitle: ''
    });
    backInStockModal.init();
}

// Format date in Norwegian
const formatDateToNorwegian = (date) => {
    const options = { day: 'numeric', month: 'long' }
    return date.toLocaleDateString('no-NO', options)
}

// Sizes
const hasValidSize = (skus) => {
    if (!skus || skus.length === 0) return false
    const sku = skus[0]
    if (sku.customFields) {
        const sizeField = sku.customFields.find((field) => field.key === 'size')
        if (sizeField && sizeField.value !== 'One Size') return true
    }
    if (sku.attributes) {
        const sizeField = sku.attributes.find((field) => field.key === 'size')
        if (sizeField && sizeField.value !== 'One Size') return true
    }
    return false
}

export const initializeWishlist = () => {
    if (window._swat) {
        if (window.SwymCallbacks.length > 0) {
            window.SwymCallbacks.forEach(callback => callback(window._swat));
        }
        window._swat.initializeActionButtons('.ns-serp')
    } else if (window.SwymCallbacks) {
        window.SwymCallbacks = window.SwymCallbacks || []
        window.SwymCallbacks.push(function () {
            window._swat.initializeActionButtons('.ns-serp')
        })
    }
}

// Add these constants at the top of the file, outside the component
const QuickBuyIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24">
        <defs>
            <mask
                id="mask"
                x=".7"
                y="0"
                width="24"
                height="24"
                maskUnits="userSpaceOnUse">
                <g id="custom">
                    <rect
                        id="bg"
                        x=".7"
                        width="24"
                        height="24"
                        fill="#fff"
                    />
                </g>
            </mask>
            <clipPath id="clippath">
                <rect x=".7" width="24" height="24" fill="none" />
            </clipPath>
        </defs>

        <g>
            <g id="svg2325">
                <g mask="url(#mask)">
                    <g id="g2331">
                        <g id="g2333">
                            <g clip-path="url(#clippath)">
                                <g id="g2335">
                                    <g id="g2341">
                                        <path
                                            id="path2343"
                                            d="M22.2,23.1H3.2l1.8-17.1h15.4l1.8,17.1Z"
                                            stroke="#000"
                                            stroke-miterlimit="10"
                                            stroke-width="1.4"
                                            fill="none"
                                        />
                                    </g>
                                    <g id="g2345">
                                        <path
                                            id="path2347"
                                            d="M9.1,8.3v-3.7c0-2,1.6-3.6,3.6-3.6h0c2,0,3.6,1.6,3.6,3.6v3.7"
                                            stroke="#000"
                                            stroke-miterlimit="10"
                                            stroke-width="1.4"
                                            fill="none"
                                        />
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
                <circle
                    cx="18.9"
                    cy="19.4"
                    r="3.8"
                    fill="#fff"
                    stroke="#000"
                    stroke-miterlimit="10"
                />
                <line
                    x1="18.9"
                    y1="17.2"
                    x2="18.9"
                    y2="21.7"
                    stroke="#000"
                    stroke-miterlimit="10"
                    stroke-width=".8"
                    fill="none"
                />
                <line
                    x1="21"
                    y1="19.4"
                    x2="16.6"
                    y2="19.4"
                    stroke="#000"
                    stroke-miterlimit="10"
                    stroke-width=".8"
                    fill="none"
                />
            </g>
        </g>
    </svg>
);

const AddToCartIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24">
        <defs>
            <mask
                id="mask"
                x=".7"
                y="0"
                width="24"
                height="24"
                maskUnits="userSpaceOnUse">
                <g id="custom">
                    <rect
                        id="bg"
                        x=".7"
                        width="24"
                        height="24"
                        fill="#fff"
                    />
                </g>
            </mask>
            <clipPath id="clippath">
                <rect x=".7" width="24" height="24" fill="none" />
            </clipPath>
        </defs>

        <g>
            <g id="svg2325">
                <g mask="url(#mask)">
                    <g id="g2331">
                        <g id="g2333">
                            <g clip-path="url(#clippath)">
                                <g id="g2335">
                                    <g id="g2341">
                                        <path
                                            id="path2343"
                                            d="M22.2,23.1H3.2l1.8-17.1h15.4l1.8,17.1Z"
                                            stroke="#000"
                                            stroke-miterlimit="10"
                                            stroke-width="1.4"
                                            fill="none"
                                        />
                                    </g>
                                    <g id="g2345">
                                        <path
                                            id="path2347"
                                            d="M9.1,8.3v-3.7c0-2,1.6-3.6,3.6-3.6h0c2,0,3.6,1.6,3.6,3.6v3.7"
                                            stroke="#000"
                                            stroke-miterlimit="10"
                                            stroke-width="1.4"
                                            fill="none"
                                        />
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
                <circle
                    cx="18.9"
                    cy="19.4"
                    r="3.8"
                    fill="#fff"
                    stroke="#000"
                    stroke-miterlimit="10"
                />
                <line
                    x1="18.9"
                    y1="17.2"
                    x2="18.9"
                    y2="21.7"
                    stroke="#000"
                    stroke-miterlimit="10"
                    stroke-width=".8"
                    fill="none"
                />
                <line
                    x1="21"
                    y1="19.4"
                    x2="16.6"
                    y2="19.4"
                    stroke="#000"
                    stroke-miterlimit="10"
                    stroke-width=".8"
                    fill="none"
                />
            </g>
        </g>
    </svg>
);

export const isMobile = window.innerWidth < 768;
const currentDate = new Date();
const numberOfSwatchesToShow = isMobile ? 3 : 6;


export default function Product({ product, swatchData, isActive, onHoverMenu, index }) {
    // const [isModalOpen, setIsModalOpen] = useState(false)
    // const [notifyClicked, setNotifyClicked] = useState(false)

    // Swatches
    const [selectedSwatch, setSelectedSwatch] = useState(product)
    const [swatchTag, setSwatchTag] = useState(null)
    const [swatchProducts, setSwatchProducts] = useState(null)
    const [primaryImage, setPrimaryImage] = useState(selectedSwatch.imageUrl);
    const [alternateImageUrl, setAlternateImageUrl] = useState(
        selectedSwatch?.alternateImageUrls != null && selectedSwatch?.alternateImageUrls.length > 0
            ? selectedSwatch?.alternateImageUrls[0]
            : selectedSwatch.imageUrl
    );

    useEffect(() => {
        // console.log('product', product)
        const tag = product?.tags1?.find((tag) => tag.includes('STYLENAME:'))
        setSwatchTag(tag)
    }, [product])
    
    useEffect(() => {
        if (!swatchTag) {
            return
        }
        const data = swatchData?.find((data) => data.groupId === swatchTag)
        const products = data ? data.products : null

        if (products) {
            setSwatchProducts(products.filter(p => p.availability !== 'OutOfStock'));
            // setSelectedSwatch(newSwatchProduct);
            const newSwatchProduct = products.find(p => p.name === product.name);
            if (newSwatchProduct) {
                setSelectedSwatch(newSwatchProduct);
            }
        }
    }, [swatchTag, swatchData])

    // Product data
    const { format } = useCurrencyFormatting()
    const discountPercentage = Math.round((1 - selectedSwatch.price / selectedSwatch.listPrice) * 100)
    // const [badgeData, setBadgeData] = useState({
    //     badges: [],
    //     // backColor: '',
    //     // textColor: '',
    //     // badgeText: '',
    //     preOrderItems: [],
    //     currentSwatchWithPreorder: null,
    // })
    const [preOrderItems, setPreOrderItems] = useState([])
    const [stock, setStock] = useState(product?.inventoryLevel)
    const [currentSkuId, setCurrentSkuId] = useState(null)
    const [isMenuVisible, setIsMenuVisible] = useState(false)
    const menuRef = useRef(null)
    const buttonRef = useRef(null)
    // set Images based on alt text
    const getPrimaryImage = (media) => {
        if (!media || !Array.isArray(media)) return null;
        if (isMobile) {
            const moodImages = media
                .filter(item => item.alt?.toUpperCase().includes('MOOD'))
                .sort((a, b) => {
                    const aNum = parseInt(a.alt.match(/MOOD_(\d+)/i)?.[1] || '999', 10);
                    const bNum = parseInt(b.alt.match(/MOOD_(\d+)/i)?.[1] || '999', 10);
                    return aNum - bNum;
                });
            if (moodImages.length > 0) return moodImages[0]?.src;
        }
        return media.find(item => item.position === 1)?.src;
    };
    const setProductImages = async (selectedSwatch) => {
        try {
          const handle = selectedSwatch?.url?.split("/products/")[1];
          if (!handle) return;
          const res = await fetch(`/products/${handle}.js`);
          if (!res.ok) throw new Error("Failed to fetch product");
          const product = await res.json();
          const media = product.media;
          setPrimaryImage(getPrimaryImage(media) || selectedSwatch.imageUrl);
          setAlternateImageUrl(
            media.find((img) => img.position === 2)?.src || selectedSwatch.imageUrl
          );
        } catch (err) {
          console.error("Error fetching product:", err);
        }
      };
      useEffect(() => {    
        const loadImages = async () => {
            await setProductImages(selectedSwatch);
        };
    
        loadImages();
    }, [selectedSwatch]);
    // Quick buy menu
    const handleQuickBuyMenu = (event) => {
        event.preventDefault()
        onHoverMenu(product.productId)
        setIsMenuVisible(!isMenuVisible)
    }
    const handleClickOutside = (event) => {
        if (
            menuRef.current &&
            !menuRef.current.contains(event.target) &&
            buttonRef.current &&
            !buttonRef.current.contains(event.target)
        ) {
            setIsMenuVisible(false)
        }
    }

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside)
        document.addEventListener('touchstart', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
            document.removeEventListener('touchstart', handleClickOutside)
        }
    }, [])

    // Updates the data according to the sku
    function handleSwatchSelect(e, prod) {
        e.preventDefault()
        setSelectedSwatch(prod)
        setCurrentSkuId(null)
        setStock(product?.inventoryLevel)
    }

    // Add to cart
    const handleAddToCart = (e, sku, selectedSwatch) => {
        e.preventDefault()
        e.stopPropagation()

        const tags = selectedSwatch.tags1;
        if (tags.includes('SHOW_SOLD_OUT') && sku?.inventoryLevel < 2) {
            return handleBackInStock(e, sku, selectedSwatch);
        }

        const productId = selectedSwatch.productId
        const skuId = sku.id
        const minicartDrawer = document.getElementById('CartDrawer')
        const htmlElement = document.querySelector('html')

        // Update the cart count
        const itemCountElement = document.querySelector('#cart-item-count')
        if (itemCountElement) {
            let count = parseInt(itemCountElement.textContent, 10)
            if (!isNaN(count)) {
                count += 1
                itemCountElement.textContent = count
            }
        }

        Nosto.addSkuToCart({ productId: productId, skuId: skuId })
        if (isMenuVisible) {
            setIsMenuVisible(!isMenuVisible)
        }

        setTimeout(function () {
            document.dispatchEvent(new CustomEvent('cart:build'))
            document.documentElement.dispatchEvent(
                new CustomEvent('cart:refresh', {
                    bubbles: true,
                })
            )
            minicartDrawer.classList.add('drawer--is-open')
            htmlElement.classList.add('js-drawer-open', 'lock-scroll')
        }, 1000)

        const closeButton = document.querySelector('#CartDrawerForm .drawer__close-button.js-drawer-close')
        if (closeButton) {
            closeButton.addEventListener('click', function () {
                minicartDrawer.classList.remove('drawer--is-open')
                htmlElement.classList.remove('js-drawer-open', 'lock-scroll')
            })
        }
    }

    // Notify when back in stock
    // const OoSSkus = product?.skus.filter((sku) => sku.availability === 'OutOfStock')
    // useEffect(() => {
    //     if (currentSkuId !== null && notifyClicked) {
    //         setIsModalOpen(true)
    //         setNotifyClicked(false) // Reset the flag
    //     }
    // }, [currentSkuId, notifyClicked])
    // const handleNotify = (e, sku) => {
    //     e.preventDefault()
    //     setCurrentSkuId(sku.id)
    //     setNotifyClicked(true)
    // }

    // Tags
    let newPreOrderItems = []

    useEffect(() => {
        let badges = []
        selectedSwatch?.tags1?.forEach((item) => {
            if (item.startsWith('DT')) {
                let parts = item.split('_')
                let startDate = new Date(parts[1])
                let endDate = new Date(parts[2])
                if (currentDate >= startDate && currentDate <= endDate) {
                    badges.push({
                        backColor: parts[3],
                        textColor: parts[4],
                        badgeText: parts[5]
                    })
                }
            } else if (item.startsWith('#PREORDER')) {
                let parts = item.split('*')
                if (parts.length > 1) {
                    let skuId = parts[0].split('-')[1]
                    let preOrderEndDate = new Date(parts[1])
                    let formattedDate = formatDateToNorwegian(preOrderEndDate)
                    if (currentDate <= preOrderEndDate) {
                        newPreOrderItems.push({ id: skuId, endDate: formattedDate })
                    }
                }
            } else if (item.startsWith('VILLOID_EXCLUSIVE')) {
                badges.push({
                    backColor: '#f3789b',
                    textColor: '#ffffff',
                    badgeText: 'VILLOID EXCLUSIVE'
                })
            }
        })
        const currentSwatchWithPreorder = newPreOrderItems.find((f) => selectedSwatch.skus?.some((sku) => sku.id === f.id))
        // setBadgeData({ badges, preOrderItems: newPreOrderItems, currentSwatchWithPreorder })
        setPreOrderItems(newPreOrderItems);
        window.dtDisplayTags();
    }, [selectedSwatch, currentSkuId])

    // Wishlist
    // const isInitialRender = useRef(true)
    // useEffect(() => {
    //     if (isInitialRender.current) {
    //         isInitialRender.current = false
    //         return
    //     }
    //     console.log('[Product] is initial render')
    //     initializeWishlist();
    // }, [selectedSwatch])

    return (
        <>
            {/* <OoSModal
                variants={OoSSkus}
                product={product}
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                selectedSku={currentSkuId}
            /> */}
            <SerpElement
                as="div"
                hit={selectedSwatch}
                class={`ns-product ns-${selectedSwatch.productId} ns-border-box ns-clickable ns-text-undecorated ns-color-inherit`}>
                <div class="grid-product__content" data-sku={currentSkuId ? currentSkuId : selectedSwatch.skus[0].id}>
                    <div class="badges" key={selectedSwatch.productId}>
                        <div class="badge badge-red dt-tag" data-tags={ selectedSwatch?.tags1}></div>

                        {/* {badgeData.currentSwatchWithPreorder && badgeData.badges.length <= 1 && <span class="badge badge-red presale">Forhåndsbestill</span>}
                        {badgeData.badges.map(badgeData => badgeData.badgeText && (
                            <a href={`https://villoid.no/collections/${badgeData.badgeText.toLowerCase()}`}>
                                <span
                                    class="badge dt-tag"
                                    style={`cursor: pointer; display: block; background: ${badgeData.backColor}; color: ${badgeData.textColor};`}>
                                    {badgeData.badgeText}
                                </span>
                            </a>
                        ))} */}
                    </div>
                    <div class="ns-overflow-visible grid-product__image-mask">
                        <a href={selectedSwatch.url} class="grid-product__link ">
                            <div class="grid-product__image-mask">
                                <div
                                    class="grid__image-ratio grid__image-ratio--portrait"
                                    style="max-height: 390px;">
                                    <img
                                        src={`${convertToImgixImage(primaryImage, 500, 800, selectedSwatch?.tags1)}`}
                                        srcset={`${convertToImgixImage(primaryImage, 500, 800, selectedSwatch?.tags1)}`}
                                        class="grid-image lazyautosizes lazyloaded"
                                        alt={selectedSwatch.name}
                                        loading={index < 10 ? "eager" : "lazy"}
                                        fetchpriority={index < 10 ? "high": "low"}
                                    />

                                    {!isMobile && (
                                        <img
                                            src={`${convertToImgixImage(alternateImageUrl, 500, 800, selectedSwatch?.tags1)}`}
                                            srcset={`${convertToImgixImage(alternateImageUrl, 500, 800, selectedSwatch?.tags1)}`}
                                            class="grid-image grid-product__secondary-image lazyload"
                                            alt={selectedSwatch.name}
                                            loading="lazy"
                                            fetchpriority={"low"}
                                        />
                                    )}
                                </div>
                            </div>
                            {swatchProducts?.length > 1 ? (
                                useMemo(() => (
                                    <div class="product-top__colors-block">
                                        <div class="ns-product-top__colors-list">
                                            {swatchProducts.slice(0, numberOfSwatchesToShow).map((prod) => {
                                                const colorSwatch = prod.skus[0]?.attributes?.find(
                                                    (f) => f.key === 'Color'
                                                )?.value
                                                const variantHandleUrl = prod?.url.split('/').pop()
                                                const productType = prod?.attributes?.find(
                                                    (attr) => attr?.key === 'productType'
                                                )?.value
                                                let swatchImage = prod.imageUrl;
                                                return (
                                                    <a
                                                        href={prod.url}
                                                        data-url={`/products/${variantHandleUrl}`}
                                                        colorSwatch={colorSwatch}
                                                        alt={prod.name}
                                                        title={prod.name}
                                                        data-swatch-product-tags={prod.tags1}
                                                        data-swatch-image-uri={swatchImage}
                                                        data-swatch-product-type={productType}
                                                        class={`ColorSwatches__Color ${
                                                            selectedSwatch.productId === prod.productId
                                                                ? 'active'
                                                                : ''
                                                        }`}
                                                        onClick={(e) => handleSwatchSelect(e, prod)}
                                                    >
                                                        {prod.name}
                                                    </a>
                                                )
                                            })}
                                            {swatchProducts.length > numberOfSwatchesToShow && (
                                                <a
                                                    href={product.url}
                                                    alt={product.name}
                                                    title={product.name}
                                                    class="ColorSwatches__Color ns-extra-swatch"
                                                >
                                                    +
                                                </a>
                                            )}
                                        </div>
                                    </div>
                                ), [swatchProducts, numberOfSwatchesToShow, product])
                            ) : (
                                <div class="nosto-no-swatches"></div>
                            )}
                            <div class="grid-product__meta ns-px-1">
                                {!selectedSwatch.tags1.includes("HYPE") && (selectedSwatch?.skus?.length > 1 ||
                                (selectedSwatch?.skus?.length === 1 && hasValidSize(selectedSwatch.skus)) ? (
                                    <button
                                        single-click="false"
                                        ref={buttonRef}
                                        className="nosto-quickbuy"
                                        onClick={handleQuickBuyMenu}
                                    >
                                        <QuickBuyIcon />
                                    </button>
                                ) : (
                                    <button
                                        single-click="true"
                                        className="nosto-quickbuy"
                                        onClick={(e) => handleAddToCart(e, selectedSwatch.skus[0], selectedSwatch)}
                                    >
                                        <AddToCartIcon />
                                    </button>
                                ))}
                                <button
                                    onClick={(e) => e.stopPropagation()}
                                    data-swaction="addToWishlist"
                                    data-event="wishlist-heart-clicked"
                                    data-with-epi="true"
                                    style="padding: 0;width: auto;position:absolute;right:0;top:-4px;z-index: 1;"
                                    class={`swym-button swym-add-to-wishlist-view-product product_${selectedSwatch.productId} swym-icontext swym-heart`}
                                    data-product-id={selectedSwatch.productId}
                                    data-variant-id={currentSkuId ? currentSkuId : selectedSwatch.skus[0].id}
                                    data-product-url={selectedSwatch.url}
                                    aria-label="Legg til i {{wishlisttitle}}."
                                ></button>
                                <div class="grid-product__title grid-product__title--heading text-uppercase">
                                    {selectedSwatch.brand}
                                </div>
                                <div class="grid-product__vendor text-transform-none">
                                    {selectedSwatch.name}
                                </div>
                                <div class="grid-product__price ns-grid-product__price">
                                    {selectedSwatch.listPrice &&
                                    selectedSwatch.listPrice > selectedSwatch.price ? (
                                        <>
                                            <span class="grid-product__price--original">
                                                <span class="money">{format(selectedSwatch.listPrice)}</span>
                                            </span>
                                            <span class="money" style="color: #db2e00;">
                                                {format(selectedSwatch.price)}
                                            </span>
                                            <span
                                                class="grid-product__price-sale ns-grid-product__price-sale"
                                                style="color: #db2e00; margin-left: 5px;">
                                                -{discountPercentage}%
                                            </span>
                                        </>
                                    ) : (
                                        <span class="money">{format(selectedSwatch.listPrice)}</span>
                                    )}
                                </div>

                                <span class="only-x-left ns-only-x-left">
                                    {!selectedSwatch.tags1.includes("SHOW_SOLD_OUT") && !selectedSwatch.tags1.includes("HYPE") && !selectedSwatch.tags1.includes("Vintage") && stock > 0 && stock < 4 && <>Bare {stock} igjen!</>}
                                </span>

                                <div
                                    ref={menuRef}
                                    className={`ns-hover-menu ${
                                        isActive && isMenuVisible && !selectedSwatch.tags1.includes("HYPE") ? 'ns-active' : ''
                                    }`}>
                                    {isActive && isMenuVisible && selectedSwatch?.skus.length > 0 && !selectedSwatch.tags1.includes("HYPE") && (
                                        <>
                                            {(() => {
                                                const sortedSkus = selectedSwatch?.skus
                                                    // ?.filter((sku) => sku?.availability === 'InStock')
                                                    ?.sort((a, b) => {
                                                        const sizeA = a?.customFields
                                                            ? a?.customFields?.find(
                                                                  (field) => field.key === 'size'
                                                              )?.value
                                                            : a?.attributes?.find((f) => f.key === 'SIZE')
                                                                  ?.value
                                                        const sizeB = b?.customFields
                                                            ? b?.customFields?.find(
                                                                  (field) => field.key === 'size'
                                                              )?.value
                                                            : b?.attributes?.find((f) => f.key === 'SIZE')
                                                                  ?.value
                                                        return customSortSizes(sizeA, sizeB)
                                                    })

                                                return (
                                                    <li
                                                        class="ns-sidebar-dropdown ns-dropdown ns-not-facet-dropdown ns-list-unstyled ns-active"
                                                        onClick={(e) => e.preventDefault()}>
                                                        <a
                                                            class="ns-quickbuy-title ns-sidebar-facet-title ns-product-dropdown ns-d-inline-block ns-relative ns-w-100 ns-border-box ns-text-undecorated"
                                                            href="javascript:void(0)">
                                                            Legg i handlekurven
                                                        </a>
                                                        <div class="ns-sidebar-submenu">
                                                            <ul class="ns-dropdown-wrapper ns-list-unstyled ns-p-0 ns-m-0">
                                                                {sortedSkus?.map((sku, index) => (
                                                                    <li
                                                                        class="ns-dropdown-option ns-d-flex ns-align-items-center"
                                                                        data-nosto-element="facet-setting"
                                                                        onClick={(e) => 
                                                                            sku?.availability === 'InStock' ? handleAddToCart(e, sku, selectedSwatch) : handleBackInStock(e, sku, selectedSwatch)
                                                                        }>
                                                                        <div class="ns-option-variant-value option-variant-value">
                                                                            {sku?.customFields
                                                                                ? sku?.customFields?.find(
                                                                                      (field) =>
                                                                                          field.key === 'size'
                                                                                  )?.value
                                                                                : sku?.attributes?.find(
                                                                                      (f) => f.key === 'SIZE'
                                                                                  )?.value}{' '}
                                                                        </div>
                                                                        {preOrderItems.some(
                                                                            (item) => item.id === sku.id
                                                                        ) ? (
                                                                            <div
                                                                                className={`ns-option-context option-${index}-left presale-true`}>
                                                                                Forhåndsbestill
                                                                                <br />
                                                                                På lager{' '}
                                                                                {
                                                                                    preOrderItems?.find(
                                                                                        (item) =>
                                                                                            item.id === sku.id
                                                                                    ).endDate
                                                                                }
                                                                            </div>
                                                                        ) : (
                                                                            (!selectedSwatch.tags1.includes("SHOW_SOLD_OUT") &&
                                                                            sku?.inventoryLevel > 0 &&
                                                                            sku?.inventoryLevel < 4) || (selectedSwatch.tags1.includes("SHOW_SOLD_OUT") && sku?.inventoryLevel > 1) ? (
                                                                                <div
                                                                                    className={`ns-option-context option-${index}-left presale-false`}
                                                                                    style={{
                                                                                        color: '#DB2E00',
                                                                                    }}>
                                                                                        {selectedSwatch.tags1.includes("SHOW_SOLD_OUT") ? (sku?.inventoryLevel < 5 ? `Kun ${sku?.inventoryLevel-1} igjen` : '') : `Kun ${sku?.inventoryLevel} igjen`}
                                                                                </div>
                                                                            ) : (
                                                                                sku?.availability !== 'InStock' || selectedSwatch.tags1.includes("SHOW_SOLD_OUT") ? (
                                                                                <div class="option-context option-0-left presale-false">
                                                                                    Få varsel når tilbake på lager
                                                                                </div>
                                                                                ) : (<></>)
                                                                            )
                                                                        )}
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    </li>
                                                )
                                            })()}
                                        </>
                                    )}
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </SerpElement>
        </>
    )
};
